import React from "react"
import PropTypes from "prop-types"

function withBrandAndModel(
  WrappedComponent,
  callbackAttrName,
  selectedItemAlias
) {
  class BrandAndModelHOC extends React.Component {
    static propTypes = {
      autoFocus: PropTypes.bool.isRequired,
      topBrands: PropTypes.array.isRequired, // ["Audi", "Nissan", "Ford"]
      all: PropTypes.array.isRequired, // [["Audi", ["A3", "A4", "Q5"]], ["BMW", ["112"]]]
      doneCallback: PropTypes.func,
      initiallySelected: PropTypes.object,
      labels: PropTypes.object,
      visibleBrands: PropTypes.array.isRequired,
      theme: PropTypes.object.isRequired,
    }

    state = {
      inputFocused: this.props.autoFocus,
      typedText: "",
      results: [
        {
          options: [],
        },
      ],
    }

    onTypedTextChange = (typedText) => {
      this.setState({ typedText })
    }

    onResultsChange = (results) => {
      this.setState({ results })
    }

    onItemselect = (item) => {
      this.setState({ ...item, typedText: item[selectedItemAlias] })

      this.props.doneCallback({
        [callbackAttrName]: item[selectedItemAlias],
      })
    }

    textInputChanged = (value) => {
      this.setState({ typedText: value })
    }

    textInputBlurred = (e) => {
      this.setState({ inputFocused: false })
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          onTypedTextChange={this.onTypedTextChange}
          onResultsChange={this.onResultsChange}
          onItemSelect={this.onItemselect}
          textInputChange={this.textInputChanged}
          textInputBlur={this.textInputBlurred}
          typedText={this.state.typedText}
          inputFocused={this.state.inputFocused}
          results={this.state.results}
        />
      )
    }
  }

  return BrandAndModelHOC
}

export default withBrandAndModel
